//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

export default {
  name: "GeographyTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  mounted: () => {

  },
  data: () => ({
    separator: "horizontal",
    pagination: {
      rowsPerPage: 10, // current rows per page being displayed
    },
    columns: [
      {
        name: "code",
        required: false,
        label: "Código",
        align: "left",
        field: (row) => (row.code),
        sortable: false,
      },
      {
        name: "name",
        required: false,
        align: "left",
        label: "Nome de loja",
        field: (row) => (row.name),
        sortable: false,
      },
      {
        name: "retalhista",
        required: false,
        align: "left",
        label: "Retalhista",
        field: (row) => (row.hierarchy[0].name),
        sortable: false,
      },
      {
        name: "insignia",
        required: false,
        align: "left",
        label: "Insignia",
        field: (row) => (row.hierarchy[1].name),
        sortable: false,
      },
      {
        name: "cadeia",
        required: false,
        align: "left",
        label: "Cadeia",
        field: (row) => (row.hierarchy[2].name),
        sortable: false,
      },
      {
        name: "zona",
        required: false,
        align: "left",
        label: "Zona",
        field: (row) => (row.geography[0].name),
        sortable: false,
      },
      {
        name: "distrito",
        required: false,
        align: "left",
        label: "Distrito",
        field: (row) => (row.geography[1].name),
        sortable: false,
      },
      {
        name: "concelho",
        required: false,
        align: "left",
        label: "Concelho",
        field: (row) => (row.geography[2].name),
        sortable: false,
      },
      {
        name: "freguesia",
        required: false,
        align: "left",
        label: "Freguesia",
        field: (row) => (row.geography[3].name),
        sortable: false,
      },
      // {
      //   name: "nielsen",
      //   align: "left",
      //   label: "Nielsen",
      //   field: "nielsen",
      //   sortable: true,
      // },
      {
        name: "address",
        required: false,
        align: "left",
        label: "Morada",
        field: (row) => (row.address),
        sortable: false,
      },
      {
        name: "postal-code",
        required: false,
        align: "left",
        label: "Código Postal",
        field: (row) => (row.postal_code),
        sortable: false,
      },
      // {
      //   name: "area",
      //   align: "left",
      //   label: "Localidade",
      //   field: "area",
      //   sortable: true,
      // },
      {
        name: "gps",
        required: false,
        align: "left",
        label: "GPS",
        field: (row) => ((row.latitude && row.longitude ? `${row.latitude} ${row.longitude}` : 'N/A')),
        sortable: false,
      }
    ],
  }),
  methods: {
    fetchRowData: function (index) {
      let data = this.data[index];
      this.$emit("clicked-row", data);
    },
    renderRightSide: function (event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event)
    }
  },
};
